import {Map} from 'immutable';
import FreeForm from './FreeForm.react';

export default Map({
  renderer: FreeForm,
  type: 'free-form',
  label: 'Free Form'
});
